import React from 'react'
import { Col, Row } from 'antd'
import { DeliveryCostConfigs } from 'Store/delivery-cost/types'
import styled from 'styled-components'
import { AppInput } from 'Components/form'
import { MyTheme } from 'Components/common/Theme'

type Props = {
  item: DeliveryCostConfigs
  activeSlider?: boolean
  onUpdateDistanceData: (key: string, val: any) => void
}

const WeightSlider: React.FunctionComponent<Props> = props => {
  const { item, activeSlider = false, onUpdateDistanceData } = props
  const unit = 'กก.'
  const max = 35000

  const onChangeSlideValue = (value: number) => {
    onUpdateDistanceData('end', value > max ? max : value)
  }

  const value = item.end
  return (
    <WeightSliderWrapper>
      <Row justify="space-between" align="middle" gutter={[16, 16]}>
        <Col span={10}>
          <InfoTitle>น้ำหนักเริ่มต้น</InfoTitle>
        </Col>
        <Col span={12}>
          <AppInput
            type="number"
            name="discount_amount"
            label=""
            value={item.start || 0}
            onChange={() => {}}
            resProps={{ allowClear: false, disabled: true, suffix: unit }}
          />
        </Col>
      </Row>
      <Row justify="space-between" align="middle" gutter={[16, 16]}>
        <Col span={10}>
          <InfoTitle>น้ำหนักสิ้นสุด</InfoTitle>
        </Col>
        <Col span={12}>
          <Center>
            <InfoTitle>ถึง</InfoTitle>
          </Center>
          <AppInput
            type="number"
            name=""
            errorMsg={`น้ำหนักมากกว่า ${item.start || 0} ${unit}`}
            label=""
            value={value}
            onChange={(val: number) => activeSlider && onChangeSlideValue(val)}
            resProps={{ allowClear: false, disabled: !activeSlider, suffix: unit }}
            isRequired={true}
            isError={!value || value <= item.start}
          />
        </Col>
      </Row>
    </WeightSliderWrapper>
  )
}

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const Center = styled.div`
  text-align: center;
`

const WeightSliderWrapper = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  min-width: 300px;
`

export default WeightSlider
